// Error Types from API given by the server
const ResponseErrorTypes = Object.freeze({
    VEEVAID_UNEXPECTED_ERROR: 'VEEVAID_UNEXPECTED_ERROR',
    VEEVAID_INVALID_USER_PASSWORD: 'VEEVAID_INVALID_USER_PASSWORD',
    VEEVAID_ACCOUNT_UNAVAILABLE: 'VEEVAID_ACCOUNT_UNAVAILABLE',
    VEEVAID_INVALID_NEW_PASSWORD: 'VEEVAID_INVALID_NEW_PASSWORD',
    VEEVAID_REGISTRATION_LINK_INVALID: 'VEEVAID_REGISTRATION_LINK_INVALID',
    VEEVAID_INVALID_PASSWORD_RESET_LINK: 'VEEVAID_INVALID_PASSWORD_RESET_LINK',
    VEEVAID_INVALID_SESSION: 'VEEVAID_INVALID_SESSION', // session is expired
    VEEVAID_REFRESH_TOKEN: 'VEEVAID_REFRESH_TOKEN', // session CSRF token issue
    VEEVAID_INVALID_RECAPTCHA: 'VEEVAID_INVALID_RECAPTCHA',
    VEEVAID_VERIFICATION_CODE_INVALID: 'VEEVAID_VERIFICATION_CODE_INVALID',
    VEEVAID_ACCOUNT_LOCKED_DISABLED: 'VEEVAID_ACCOUNT_LOCKED_DISABLED',
    VEEVAID_RESEND_VERIFICATION_CODE: 'VEEVAID_RESEND_VERIFICATION_CODE',
    VEEVAID_INSECURE_PASSWORD: 'VEEVAID_INSECURE_PASSWORD',
    VEEVAID_CODE_RESEND_LIMIT: 'VEEVAID_CODE_RESEND_LIMIT',
    VEEVAID_INVALID_DATA: 'VEEVAID_INVALID_DATA',
    VEEVAID_INVALID_APP_ID: 'VEEVAID_INVALID_APP_ID',
    VEEVAID_USERPROFILE_NOT_FOUND: 'VEEVAID_USERPROFILE_NOT_FOUND',
    VEEVAID_EMAIL_NOT_AVAILABLE: 'VEEVAID_EMAIL_NOT_AVAILABLE',
    VEEVAID_INVALID_USERNAME_PASSWORD: 'VEEVAID_INVALID_USERNAME_PASSWORD',
});

export default ResponseErrorTypes;
